module.exports = __webpack_public_path__ + "img/tornado.3756fe92.jpg";